












import Vue from 'vue'
import Component from 'vue-class-component'
import BillingFlow from './components/BillingFlow.vue'
import GeneralCollectionsSettings from './components/GeneralCollectionsSettings.vue'

@Component({
  name: 'FacilityCollectionsManagement',
  components: {
    BillingFlow,
    GeneralCollectionsSettings
  }
})
export default class FacilityCollectionsManagement extends Vue {

}
